import React, { memo } from 'react'
import PropTypes from 'prop-types'

import styles from './separator.module.scss'

function Separator(props) {
  const { width, height, spacing } = props

  return (
    <div
      className={styles.wrapper}
      style={{
        marginTop: spacing,
        marginBottom: spacing,
      }}
    >
      <div
        className={styles.body}
        style={{ width, height }}
      />
    </div>
  )
}

Separator.defaultProps = {
  width: 50,
  height: 5,
  spacing: 0,
}

Separator.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  spacing: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}

export default memo(Separator)
